import { render, staticRenderFns } from "./BroadcastChannel.vue?vue&type=template&id=570bdb31&"
import script from "./BroadcastChannel.vue?vue&type=script&lang=ts&"
export * from "./BroadcastChannel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports